import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../features/auth/authSlice";
import { getGroupage } from "../features/groupages/groupageSlices";
import GroupageItemCard from "../components/GroupageItemCard";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  InputAdornment,
  Link,
  Stack,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import {
  getShipmentByCNPublic,
  reset,
} from "../features/shipments/shipmentSlice";
import Copyright from "../components/Copyright";

const prefix = "SKY-";
const Tracking = () => {
  let { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [shipmentNo, setShipmentNo] = useState("");
  const [formError, setFormError] = useState(false);
  const [navigateFlag, setNavigateFlag] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { shipment, isSuccess, isError, message, isLoading } = useSelector(
    (state) => state.shipments
  );

  const handleSearch = (e) => {
    e.preventDefault();
    setNavigateFlag(false);
    if (shipmentNo.length <= 0) {
      setFormError(true);
      return;
    }
    setNavigateFlag(true);
    dispatch(getShipmentByCNPublic(prefix + shipmentNo));
  };

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  useEffect(() => {
    if (shipment.id && isSuccess && navigateFlag) {
      navigate(`/shipment/${shipment.id}`);
    }
  }, [shipment, navigateFlag, isSuccess]);

  return (
    <>
      <CssBaseline />

      <Grid
        container
        component="main"
        justifyContent="center"
        alignItems="center"
        sx={{
          height: "100vh",
        }}
      >
        <Grid
          item
          xs={12}
          sm={8}
          md={6}
          lg={4}
          xl={3}
          component={Paper}
          elevation={6}
          square
          alignContent="center"
        >
          <Stack alignItems="center" sx={{ mb: 5 }}>
            <img id="searchLogo" src="/skylog-logo.png" alt="SKYLOG v2" />
            <Typography
              variant="body2"
              sx={{ mt: -5, mb: 4 }}
              textAlign="center"
            >
              v2.5
            </Typography>
            <Container maxWidth="sm" component="form" onSubmit={handleSearch}>
              <Stack direction={"column"} spacing={2} textAlign={"center"}>
                <Link href="/">Sign In</Link>
                <Typography variant="h6">Track Shipment</Typography>
                <TextField
                  fullWidth
                  label="Shipment / CN Number"
                  value={shipmentNo}
                  onChange={(e) => setShipmentNo(e.target.value)}
                  error={formError}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{prefix}</InputAdornment>
                    ),
                  }}
                  onSubmit={handleSearch}
                />
                {isError && <Typography color="red">{message}</Typography>}
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSearch}
                >
                  Search
                </Button>
              </Stack>
            </Container>
          </Stack>
          <Copyright sx={{ my: 5 }} />
          <img id="skytransLogo" src="/SKY2021.png" alt="SKYTRANS LOGISTICS" />
        </Grid>
      </Grid>
    </>
  );
};

export default Tracking;
